module.exports = __webpack_public_path__ + "assets/img/logo-14c1a70f.png";